import {useState} from "react";
import {Link} from "react-router-dom";
import {useIsAdmin} from "../../hooks/useIsAdmin";

export const CampaignMenu = (props) => {
    const [open, setOpen] = useState(false)
    const isAdmin = useIsAdmin();

    return <div className="self-end w-fit ps-8 z-10 relative">
        <button
            onClick={() => setOpen(!open)}
            className="w-10 h-10 inline-flex items-center justify-center text-ink bg-canvas border border-hairline rounded-full hover:bg-surface-soft transition-colors"
            type="button"
        >
            <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 4 15">
                <path d="M3.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6.041a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5.959a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"/>
            </svg>
        </button>
        <div className={`${!open ? "hidden" : ""} absolute right-0 mt-2 z-20 bg-canvas border border-hairline rounded-md shadow-card overflow-hidden min-w-[220px]`}>
            <ul className="text-body-md text-ink">
                {isAdmin && (
                    <li
                        onClick={() => {
                            props.setShowSubmissionDialog(!props.showSubmissionDialog);
                            setOpen(false);
                        }}
                        className="cursor-pointer px-4 py-3 border-b border-hairline hover:bg-surface-soft transition-colors"
                    >
                        <span className="self-center">Send submission</span>
                    </li>
                )}
                <Link
                    onClick={() => {
                        props.openSubmissions && props.openSubmissions(props.campaign._id)
                    }}
                    className="flex flex-row text-ink cursor-pointer px-4 py-3 border-b border-hairline hover:bg-surface-soft transition-colors"
                    to="/analytics"
                >
                    <p>Submissions</p>
                </Link>
                <li
                    onClick={async () => {
                        await navigator.clipboard.writeText(props.campaign._id);
                        props.showMessage("Copied to clipboard!");
                        setOpen(false);
                    }}
                    className="flex flex-col px-4 py-3 cursor-pointer hover:bg-surface-soft transition-colors"
                >
                    <span className="self-start">Copy Campaign Id</span>
                    <span className="text-[12px] text-muted mt-1">{props.campaign._id}</span>
                </li>
            </ul>
        </div>
    </div>
}
